import {viewModel} from "@/class/view-model";
import store from "@/store/store";
import {DateTime, Media, PK} from "@/class/data-type";

export class map extends viewModel{
    
    objectType = "map";
    
    /**
     * variables de données
     */
    _pk = new PK("id");
    
    data = [
        {name: "name", type: String, default: "A renseigner"},
        {name: "title", type: String, default: ""},
        {name: "intro_subtitle", type: String, default: ""},
        {name: "intro_text", type: String, default: ""},
        {name: "intro_image", type: Media, default: new Media({type:"picture"})},
        {name: "creation_date", type: DateTime, default: new DateTime(), readonly:true},
        {name: "update_date", type: DateTime, default: new DateTime()},
    ]
    
    constructor() {
        super();
        this.init()
    }
    
    getThumbnail(){
        return this.intro_image.media || store.getters.getDefault("BaseImage");
    }
}